import { JavaCurrencyValue } from "../../../utils/currency";
import { ViewType } from "../types";
import { ProductBarChartTransaction } from "./types";

export function toNumericValue(value: JavaCurrencyValue | number): number {
  return typeof value === "number" ? value : Number(value.displayAmount);
}

export function rankKey(i: number) {
  return `rank_${i}`;
}

export function rankIndexOf(dataKey: string) {
  return Number(dataKey.split("_")[1]);
}

export function getBucketKey(
  t: ProductBarChartTransaction,
  viewType: ViewType
) {
  if (viewType === "QUARTERLY") return `${t.quarter} ${t.year}`;
  if (viewType === "ANNUALLY") return t.year;
  return `${t.month} ${t.year}`;
}
